import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/mobile/shevron_right.svg'


const _withScopeId = n => (_pushScopeId("data-v-6f3bb228"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item" }
const _hoisted_2 = { class: "w-full rounded-t-[50px] bg-slate-400 bg-cover" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "px-[30px] pt-3 border-x-[3px] border-b-[3px] border-x-[var(--primary-color)] border-b-[var(--primary-color)] border-t-none rounded-b-[50px]" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-[6px] rounded w-full bg-[var(--secondary-color)]" }, null, -1))
const _hoisted_6 = { class: "flex py-6 items-end" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_10 = { class: "ml-auto w-[46px] h-[46px] cursor-pointer" }
const _hoisted_11 = {
  key: 0,
  src: _imports_0,
  class: "ml-auto"
}
const _hoisted_12 = ["src"]

import { toRefs, ref } from 'vue';
import BaseTypography from '@/components/common/BaseTypography.vue';
import arrowRight from '@/assets/svg/arrow-right.svg';
import arrowRightGreen from '@/assets/svg/arrow-right-green.svg';
import { useGlobalStore } from '@/stores/global';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SlideItem',
  props: {
    id: {},
    title: {},
    text: {},
    url: {},
    price: {}
  },
  setup(__props: any) {



const { isMobile } = toRefs(useGlobalStore());
const { t } = useI18n();

const strapiUrl = process.env.VUE_APP_STRAPI_URL;
const isHoveredArrow = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: `${_unref(strapiUrl)}${_ctx.url}`,
        class: "w-[428px] h-[234px] object-cover rounded-t-[50px]"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createVNode(BaseTypography, {
          text: _ctx.title,
          type: _unref(isMobile) ? 'body2-m' : 'special-body',
          color: "var(--primary-color)",
          class: "mb-3 min-h-[52px]"
        }, null, 8, ["text", "type"]),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(BaseTypography, {
            text: _ctx.text,
            type: _unref(isMobile) ? 'body3-m' : 'body3',
            color: "var(--black-color)",
            class: "l:min-h-20"
          }, null, 8, ["text", "type"]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.price)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(BaseTypography, {
                    text: _ctx.price.toString(),
                    type: _unref(isMobile) ? 'body-m' : 'special-body2',
                    tag: "span",
                    color: "var(--secondary-color)"
                  }, null, 8, ["text", "type"]),
                  _createVNode(BaseTypography, {
                    text: _unref(t)('common.people'),
                    type: _unref(isMobile) ? 'body-m' : 'special-body2',
                    tag: "span"
                  }, null, 8, ["text", "type"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              (_unref(isMobile))
                ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: isHoveredArrow.value ? _unref(arrowRightGreen) : _unref(arrowRight),
                    class: "ml-auto",
                    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHoveredArrow.value = true)),
                    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHoveredArrow.value = false))
                  }, null, 40, _hoisted_12))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})